import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { httpClient } from "../../utils/HttpClient";
import { ApiEndpoint } from "../../utils/ApiEndpoint";
import { useAuth } from "../../Context/AuthContext";
import { Col, FloatingLabel, Form, Row } from "react-bootstrap";
import PropTypes from "prop-types";
import * as AiIcons from "react-icons/ai";
const WhatsappMessageEdit = ({
  onChangeWhatsappMessage,

  cleanWhatsappParameters,

  changeHandler,
  valueParameters,
  onChangeWhatsappTemplate,
}) => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [templatesList, setTemplatesList] = useState(null);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [parametersCount, setParametersCount] = useState(null);
  async function getTemplates() {
    try {
      const URI = ApiEndpoint + "whatsapp/templates";
      httpClient("GET", URI, {}, userData.token).then((response) => {
        console.log(response.data);
        setTemplatesList(response.data);
      });
    } catch (error) {
      console.error(
        "Error fetching templates:",
        error.response?.data || error.message
      );
    }
  }

  async function getTemplateMessage() {
    try {
      const URI = ApiEndpoint + "whatsapp/templates";
      httpClient("GET", URI, {}, userData.token).then((response) => {
        let templateData = response.data.filter(
          (x) => x.id == selectedTemplate
        );
        let message = templateData[0].data;
        setParametersCount(getWhatsappParameters(message));
        console.log(parametersCount);
        onChangeWhatsappMessage(message);
      });
    } catch (error) {
      console.error(
        "Error fetching templates:",
        error.response?.data || error.message
      );
    }
  }
  useEffect(() => {
    if (!templatesList) getTemplates();
  }, []);

  function getWhatsappParameters(texto) {
    const matches = texto.match(/{{\d+}}/g);
    const unicos = new Set(matches);
    return matches ? unicos.size : 0;
  }

  useEffect(() => {
    if (selectedTemplate) getTemplateMessage();
  }, [selectedTemplate]);
  return (
    <>
      {templatesList && (
        <>
          <FloatingLabel label="Plantilla *" className="mb-3">
            <Form.Select
              id="selectedTemplate"
              name="selectedTemplate"
              onChange={(selectedOption) => {
                onChangeWhatsappTemplate(selectedOption.target.value);
                setSelectedTemplate(selectedOption.target.value);
              }}
              value={selectedTemplate}
              required
              aria-label="select_carrier"
            >
              <option value="">Seleccione una opción de la lista</option>
              {!!templatesList?.length &&
                templatesList.map((template) => (
                  <option key={template.elementName} value={template.id}>
                    {template.elementName}
                  </option>
                ))}
            </Form.Select>
          </FloatingLabel>
          <hr />
          {/* <Row>
            <Col>
              <Form.Control
                as="textarea"
                name={name}
                id={name}
                value={defaultValue || ""}
                visible={false}
                disabled={true}
                onChange={(event) => {
                  changeHandler(event);
                }}
                placeholder="Escribe el mensaje:"
                style={{ height: "100px", resize: "none" }}
              />
            </Col>
          </Row> */}
          <Row>
            <Col>
              <b>Parámetros:</b>
            </Col>
            <Col className="text-end">
              <AiIcons.AiOutlineDelete
                className="IconTable"
                title="Limpiar parametros"
                onClick={() => {
                  cleanWhatsappParameters();
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <span className="SpamWarning">
                Seleccione los parametros que apareceran en el mensaje, en el
                orden que deben aparecer
              </span>
            </Col>
          </Row>

          <Row>
            <Col>
              <Form.Control
                as="textarea"
                name="parameters"
                id="parameters"
                value={valueParameters || ""}
                required
                disabled={true}
                onChange={(event) => {
                  //  setCount(event.target.value.length);
                  console.log(event.target.value);
                  changeHandler(event);
                }}
                placeholder="Seleccione los parametros de la lista de plantillas"
                style={{ height: "100px", resize: "none" }}
              />
            </Col>
          </Row>
          <hr />
        </>
      )}
    </>
  );
};
WhatsappMessageEdit.propTypes = {
  onChangeWhatsappMessage: PropTypes.func.isRequired,

  cleanWhatsappParameters: PropTypes.func.isRequired,
  changeHandler: PropTypes.func.isRequired,
  valueParameters: PropTypes.string,
  onChangeWhatsappTemplate: PropTypes.func.isRequired,
};
export default WhatsappMessageEdit;
